export default {"src":"/_next/static/media/ico_nextgray.3c55af34.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};